module.exports = {"510184001":"崇阳街道","510184002":"羊马街道","510184003":"三江街道","510184004":"江源街道","510184005":"大划街道","510184006":"崇庆街道","510184104":"廖家镇","510184105":"元通镇","510184106":"观胜镇","510184107":"怀远镇","510184109":"街子镇","510184110":"文井江镇","510184112":"白头镇","510184113":"道明镇","510184114":"隆兴镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510184.json
// module id = 2403
// module chunks = 0